// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__6QBjT","hand":"Home_hand__78ca0","wave":"Home_wave__qq5kH"};